import { render, staticRenderFns } from "./allLog.vue?vue&type=template&id=63939500&scoped=true"
import script from "./allLog.vue?vue&type=script&lang=js"
export * from "./allLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63939500",
  null
  
)

export default component.exports